import App from '../../components/App';
import props from '../../configs/propsTextArt';
import TextArtStaticSection from '../../sections/static/TextArt';

export default function FontGenerator() {
  return (
    <App {...props}>
      <TextArtStaticSection />
    </App>
  );
}
